(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('stato-odg', {
            parent: 'entity',
            url: '/stato-odg',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.statoODG.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/stato-odg/stato-odgs.html',
                    controller: 'StatoODGController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statoODG');
                    $translatePartialLoader.addPart('statoODGType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('stato-odg-detail', {
            parent: 'stato-odg',
            url: '/stato-odg/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.statoODG.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/stato-odg/stato-odg-detail.html',
                    controller: 'StatoODGDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statoODG');
                    $translatePartialLoader.addPart('statoODGType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'StatoODG', function($stateParams, StatoODG) {
                    return StatoODG.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'stato-odg',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('stato-odg-detail.edit', {
            parent: 'stato-odg-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/stato-odg/stato-odg-dialog.html',
                    controller: 'StatoODGDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StatoODG', function(StatoODG) {
                            return StatoODG.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('stato-odg.new', {
            parent: 'stato-odg',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/stato-odg/stato-odg-dialog.html',
                    controller: 'StatoODGDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                stato: null,
                                dataOraCambioStato: null,
                                utenteCambioStato: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('stato-odg', null, { reload: 'stato-odg' });
                }, function() {
                    $state.go('stato-odg');
                });
            }]
        })
        .state('stato-odg.edit', {
            parent: 'stato-odg',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/stato-odg/stato-odg-dialog.html',
                    controller: 'StatoODGDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StatoODG', function(StatoODG) {
                            return StatoODG.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('stato-odg', null, { reload: 'stato-odg' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('stato-odg.delete', {
            parent: 'stato-odg',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/stato-odg/stato-odg-delete-dialog.html',
                    controller: 'StatoODGDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['StatoODG', function(StatoODG) {
                            return StatoODG.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('stato-odg', null, { reload: 'stato-odg' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
